import { toBrazilianDate } from '../../../../helpers/utils/utils';

/**
 * Mapper puro DTO real (`buscarDocumentosProcessoPorIdProcessoService`) →
 * shape de UI (AW2-1094 Etapa 1) — mesmos nomes de campo já usados pelo mock
 * estático que este mapper substitui (`DOCUMENTOS`, `constants/processos.constants.js`:
 * `id`/`extensao`/`tipo`/`descricao`/`nomeArquivo`/`originalArquivada`/
 * `oculto`/`data`), para minimizar o diff em `AbaDocumentos.jsx`. `responsavel`
 * é campo novo (coluna "Responsável", confirmada existente na tela real —
 * `TableBodyDocumentosProcesso.jsx` — ausente do texto do AC2 do Jira).
 *
 * Sem `textOverflow` (mesma decisão já tomada em `documentosClienteController.js`,
 * AW2-1136 Etapa 5): o protótipo não reproduz a largura fixa de coluna da
 * tabela real — a truncagem visual já é feita via CSS + Tooltip em
 * `AbaDocumentos.jsx`, mostrar o texto completo no dado é mais fiel, não
 * menos.
 *
 * `oculto` usa o mesmo default da produção real (`ocultarDocumentoCliente !== false`
 * — `true` a menos que o backend envie explicitamente `false`).
 */
function mapearDocumento(documento) {
  const nomeArquivo = documento?.nomeDocumento
    ? `${documento.nomeDocumento}.${documento.extensao}`
    : '';

  return {
    id: documento?.idProcessoDocumento ?? -1,
    extensao: documento?.extensao ?? '',
    tipo: documento?.tipo ?? '',
    descricao: documento?.descricao ?? '',
    nomeArquivo,
    originalArquivada: documento?.serDocumentoOriginal ?? false,
    oculto: documento?.ocultarDocumentoCliente !== false,
    data: toBrazilianDate(documento?.dataArquivamento) || '',
    responsavel: documento?.nomeUsuario ?? '',
  };
}

export function mapearDocumentos(content) {
  return (content || []).map(mapearDocumento);
}

/**
 * Seleção com persistência entre páginas (AW2-1094 Etapa 2) — funções puras
 * IMUTÁVEIS sobre o Map `allIdsDocumentos` (`Map<idProcessoDocumento, boolean>`,
 * já buscado pelo container na Etapa 0). Deliberadamente não replicam a
 * mutação direta de `TableUtils.updateAllItensSelectionByNewSelectionValue`/
 * `updateUniqueItemSelectionByCurrentId` (anti-padrão já documentado em
 * `src/prototipo/CLAUDE.md` — mutam `item.checked` fora de `setState`).
 */
export function alternarSelecaoId(map, id) {
  const proximo = new Map(map);
  proximo.set(id, !map.get(id));
  return proximo;
}

export function alternarSelecionarTodos(map, novoValor) {
  const proximo = new Map(map);
  proximo.forEach((_, id) => proximo.set(id, novoValor));
  return proximo;
}

export function contarSelecionados(map) {
  let contagem = 0;
  map.forEach((valor) => {
    if (valor) {
      contagem += 1;
    }
  });
  return contagem;
}

export function estaTudoSelecionado(map) {
  return map.size > 0 && contarSelecionados(map) === map.size;
}
